import styled from 'styled-components';
import WaterIcon from '@/assets/mo/water.svg?react';
import FeeIcon from '@/assets/mo/fee.svg?react';
import TherapyIcon from '@/assets/mo/therapy.svg?react';
import AppointmentIcon from '@/assets/mo/free-appointment.svg?react';

const HotBadgeSlider = () => {
  return (
    <Container>
      <Title>요즘 다들 이만큼 받았어요</Title>
      <CardList>
        <Card>
          <CardContent>
            <TextGroup>
              <Label>최근 많은</Label>
              <Value>평균 167만원 보험금 수령</Value>
            </TextGroup>
            <IconGroup>
              <WaterIcon />
              <IconLabel>누수</IconLabel>
            </IconGroup>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <TextGroup>
              <Label>HOT</Label>
              <Value>평균 2900만원 보험금 수령</Value>
            </TextGroup>
            <IconGroup>
              <FeeIcon />
              <IconLabel>진단금/기타</IconLabel>
            </IconGroup>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <TextGroup>
              <Label>HOT</Label>
              <Value>평균 157만원 보험금 수령</Value>
            </TextGroup>
            <IconGroup>
              <AppointmentIcon />
              <IconLabel>무료선임</IconLabel>
            </IconGroup>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <TextGroup>
              <Label>HOT</Label>
              <Value>평균 89만원 보험금 수령</Value>
            </TextGroup>
            <IconGroup>
              <TherapyIcon />
              <IconLabel>도수치료</IconLabel>
            </IconGroup>
          </CardContent>
        </Card>
      </CardList>
    </Container>
  );
};

export default HotBadgeSlider;

// ✅ styled-components는 동일
const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1240px;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  background: var(--Primary-lightgray, #f3f3f3);
  box-sizing: border-box;
  border-radius: 8px;
`;

const Title = styled.div`
  color: var(--gray-ui_gray01, #191919);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.36px;
`;

const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  height: 209px;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  flex: 1 1 calc(25% - 6px); // 4개씩
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    flex: 1 1 calc(50% - 4px); // 2개씩
  }

  @media (max-width: 600px) {
    flex: 1 1 100%; // 1개씩
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const Label = styled.div`
  padding: 2px 0;
  color: var(--gray-ui_gray05, #999);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.28px;
`;

const Value = styled.div`
  color: var(--Primary-brand_01, #0b46dd);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconLabel = styled.div`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
